import { render } from "./VendorDeleteFormModal.vue?vue&type=template&id=3850d2bd&lang=pug"
import script from "./VendorDeleteFormModal.vue?vue&type=script&lang=ts"
export * from "./VendorDeleteFormModal.vue?vue&type=script&lang=ts"
script.render = render

export default script